<template>
    <activation-brief-products-provider
        v-slot="{
            brief,
            step,
            patchStep,
            goNextStep,
            goPreviousStep,
            isLoading,
            isCompletingBrief,
            errors,
            errorMessage
        }"
        :is-additional-order="isAdditionalOrder"
        class="g-h-full"
    >
        <activation-brief-products-view
            v-if="brief"
            :brief="brief"
            :step="step"
            :is-loading="isLoading"
            :is-completing-brief="isCompletingBrief"
            :is-additional-order="isAdditionalOrder"
            :errors="errors"
            :error-message="errorMessage"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
            @patch-step="patchStep"
        />
    </activation-brief-products-provider>
</template>

<script>
    import ActivationBriefProductsProvider from '../providers/activation-brief-steps/ActivationBriefProductsProvider';
    import ActivationBriefProductsView from '../data-views/activation-briefs/ActivationBriefProductsView';

    export default {
        name:       'ActivationBriefProductsRouterView',
        props: {
            isAdditionalOrder: {
                type:    Boolean,
                default: false,
            }
        },
        components: {
            ActivationBriefProductsProvider,
            ActivationBriefProductsView,
        },
    };
</script>
